var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuspreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 510,
    viewBox: "0 0 510 510",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M385.378 415.25L333.878 363.75H123.5L200.75 260.75L258.688 338L279.802 309.675L97.75 127.622V415.25H385.378ZM170.622 54.75L458.25 342.378V54.75H170.622Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M453.458 56.3925V344.02L504.958 395.52V56.3925C504.958 28.0675 481.783 4.8925 453.458 4.8925H114.33L165.83 56.3925H453.458ZM36.565 0L0 36.3075L41.4575 77.765V416.893C41.4575 445.218 64.6325 468.393 92.9575 468.393H432.085L473.543 509.85L509.85 473.543L36.565 0ZM92.9575 416.893V129.265L275.01 311.318L253.895 339.643L195.958 262.393L118.708 365.393H329.085L380.585 416.893H92.9575Z",
    fill: "#ED3237"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuspreview);
export default __webpack_public_path__ + "static/media/docuspreview.24866cce5a300fcc60f7bb7c814d57e4.svg";
export { ForwardRef as ReactComponent };